import moment from 'moment';

// UTC timestamp from the API -> the viewer's local "Sep 11, 2026" + "2:32 pm". null when
// missing/invalid. The footer tells the viewer which zone that is.
const formatOrderDate = (utcTimestamp?: string | null) => {
  if (!utcTimestamp) return null;
  const local = moment.utc(utcTimestamp).local();
  if (!local.isValid()) return null;
  return { date: local.format('MMM D, YYYY'), time: local.format('h:mm a') };
};

// Same, as one string for read-only fields: "Sep 11, 2026 · 2:32 pm". '' when missing/invalid.
export const formatOrderDateTime = (utcTimestamp?: string | null) => {
  const parts = formatOrderDate(utcTimestamp);
  return parts ? `${parts.date} · ${parts.time}` : '';
};

// A date without a time of day (lot expiry): "Sep 11, 2026". Only the calendar date is read,
// so a value with a time zone suffix cannot slip to the previous day. Unrecognised input is
// shown as typed.
export const formatDateOnly = (value?: string | null) => {
  if (!value) return '';
  const parsed = moment(String(value).slice(0, 10), 'YYYY-MM-DD', true);
  return parsed.isValid() ? parsed.format('MMM D, YYYY') : String(value);
};

// Two calendar dates as one label: "Sep 6 – 12, 2026", "Aug 30 – Sep 5, 2026",
// "Dec 28, 2025 – Jan 3, 2026", or just "Sep 12, 2026" for a single day.
export const formatDateRange = (from: string, to: string) => {
  const start = moment(from, 'YYYY-MM-DD', true);
  const end = moment(to, 'YYYY-MM-DD', true);
  if (!start.isValid() || !end.isValid()) return '';
  if (start.isSame(end, 'day')) return start.format('MMM D, YYYY');
  if (start.isSame(end, 'month')) {
    return `${start.format('MMM D')} – ${end.format('D, YYYY')}`;
  }
  if (start.isSame(end, 'year')) {
    return `${start.format('MMM D')} – ${end.format('MMM D, YYYY')}`;
  }
  return `${start.format('MMM D, YYYY')} – ${end.format('MMM D, YYYY')}`;
};

export default formatOrderDate;
